/**
 * Frontend Page Routes
 *
 * All page routes used for navigation in the application.
 * These correspond to the /src/app directory structure.
 */

export const ROUTES = {
  // Public routes
  HOME: '/',
  LOGIN: '/login',
  DASHBOARD: '/dashboard',

  // Core features
  DETECT: '/detect',
  HISTORY: '/history',
  PROJECTS: '/projects',

  // Management
  CONTRACTORS: '/contractors',
  TICKETS: '/tickets',
  EMAIL_TEMPLATES: '/email-templates',

  // Admin & Settings
  ADMIN: '/admin',
  ADMIN_USERS: '/admin/users',
  ADMIN_AI_TRAINING: '/admin/ai-training', // AI Training - ADMIN + SUPERUSER
  ADMIN_TELEGRAM: '/admin/telegram', // Bautagebuch - ADMIN + SUPERUSER
  ADMIN_TESTER_FEEDBACK: '/admin/tester-feedback', // Tester-Feedback - ADMIN + SUPERUSER
  SYSTEM_SETTINGS: '/system-settings', // AI settings - SUPERUSER only
  BILLING: '/billing',

  // Legacy/Other
  KONZEPT: '/konzept',
  
  // Floor Plan
  FLOORPLAN: '/projects/[id]/floorplan',

  // Testing
  TEST: '/test',
} as const

export type PageRoute = typeof ROUTES[keyof typeof ROUTES]
